import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-arrow_right",
  "use": "rt-base-arrow_right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-base-arrow_right\">\n<path d=\"M737.7,486.7l-450.8-353c-5.3-4.1-12.9-0.4-12.9,6.3v77.5c0,4.9,2.3,9.6,6.1,12.6l360,281.8l-360,281.8\n\tc-3.9,3-6.1,7.7-6.1,12.6V884c0,6.7,7.7,10.4,12.9,6.3l450.8-353C754.1,524.4,754.1,499.6,737.7,486.7L737.7,486.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/arrow_right.svg
// module id = 1226
// module chunks = 116